import { render } from "./TextStudy.vue?vue&type=template&id=2cb66dcb&scoped=true"
import script from "./TextStudy.vue?vue&type=script&lang=js"
export * from "./TextStudy.vue?vue&type=script&lang=js"

import "./TextStudy.vue?vue&type=style&index=0&id=2cb66dcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb66dcb"]])

export default __exports__